import merge from '~lodash.mergewith'
import * as CoreSdk from '~@sentry/core'
import { captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } from '~@sentry/browser'
import { extraErrorDataIntegration } from '~@sentry/integrations'
import { init } from '~@sentry/vue'

export { init }
export const SentrySdk = { ...CoreSdk, ...{ captureUserFeedback, forceLoad, onLoad, showReportDialog, wrap } }

/** @type {string[]} */
const DISABLED_INTEGRATION_KEYS = ["ReportingObserver"]

/**
 * @typedef {Parameters<typeof init>[0]} InitConfig
 * @param {import('@nuxt/types').Context} ctx
 * @return {Promise<InitConfig>}
 */
export function getConfig (ctx) {
  /** @type {InitConfig} */
  const config = {
    dsn:"https:\u002F\u002F5e6c4a625a6d40c9bc5b1f9cc02cdbe4@sentry.aws.delfi.net\u002F37",
    environment:"production",
    enabled:true,
    release:"1.31.18",
    sampleRate:0.5,
    tracesSampleRate:0.5,
    beforeSend:function(event) {
        // Filter out UnhandledRejection errors that have no information
        if (event !== undefined && event.exception !== undefined && event.exception.values !== undefined && event.exception.values.length === 1) {
          const e = event.exception.values[0];
          if (e.type === 'UnhandledRejection' && e.value === 'Non-Error promise rejection captured with value: undefined') {
            return null;
          }
        }

        return event;
      },
    allowUrls:[new RegExp("https?:\\\u002F\\\u002F([a-z0-9]*\\.)?(?:delfi|dcdn)\\.(?:ee|net|lv|lt)", "")],
    denyUrls:[new RegExp("g\\.delfi\\.lt\\\u002Fscms", ""),new RegExp("g\\.delfi\\.lt\\\u002Fmisc\\\u002Frembi", "")],
    ignoreErrors:["originalCreateNotification","canvas.contentDocument","bmi_SafeAddOnload","EBCallBackMessageReceived","AbortError","NotAllowedError","Blocked a frame with origin","Network Error"],
  }

  /** @type {NonNullable<InitConfig>['integrations']} */
  const resolvedIntegrations = [
    extraErrorDataIntegration(),
  ]

  config.integrations = (defaultIntegrations) => {
    return [
      ...defaultIntegrations.filter(integration => !DISABLED_INTEGRATION_KEYS.includes(integration.name)),
      ...resolvedIntegrations,
    ]
  }
  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  return config
}
